var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#16304F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.78 13.159C17.6394 13.0185 17.4488 12.9397 17.25 12.9397C17.0512 12.9397 16.8606 13.0185 16.72 13.159L14.75 15.129V7.75C14.75 7.55109 14.671 7.36032 14.5303 7.21967C14.3897 7.07902 14.1989 7 14 7C13.8011 7 13.6103 7.07902 13.4697 7.21967C13.329 7.36032 13.25 7.55109 13.25 7.75V15.129L11.28 13.159C11.1378 13.0265 10.9498 12.9544 10.7555 12.9578C10.5612 12.9613 10.3758 13.04 10.2384 13.1774C10.101 13.3148 10.0223 13.5002 10.0188 13.6945C10.0154 13.8888 10.0875 14.0768 10.22 14.219L13.47 17.469L14 18L14.53 17.47L17.78 14.22C17.8497 14.1504 17.905 14.0676 17.9427 13.9766C17.9804 13.8856 17.9998 13.788 17.9998 13.6895C17.9998 13.591 17.9804 13.4934 17.9427 13.4024C17.905 13.3114 17.8497 13.2287 17.78 13.159ZM8.5 15.75C8.5 15.5511 8.42098 15.3603 8.28033 15.2197C8.13968 15.079 7.94891 15 7.75 15C7.55109 15 7.36032 15.079 7.21967 15.2197C7.07902 15.3603 7 15.5511 7 15.75V19C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V15.75C21 15.5511 20.921 15.3603 20.7803 15.2197C20.6397 15.079 20.4489 15 20.25 15C20.0511 15 19.8603 15.079 19.7197 15.2197C19.579 15.3603 19.5 15.5511 19.5 15.75V19C19.5 19.1326 19.4473 19.2598 19.3536 19.3536C19.2598 19.4473 19.1326 19.5 19 19.5H9C8.86739 19.5 8.74021 19.4473 8.64645 19.3536C8.55268 19.2598 8.5 19.1326 8.5 19V15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.a3abdffee27aecc6e7291de56bcd28f6.svg";
export { ForwardRef as ReactComponent };